import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import NumberFormat from "react-number-format";
import { StyledTextField, StyledWrapper } from "./styles";

const NumberFormatCustom = ({ inputRef, onChange, decimals, ...rest }) => (
  <NumberFormat
    {...rest}
    getInputRef={inputRef}
    onValueChange={values => {
      onChange(values);
    }}
    pattern="\d*"
    decimalScale={decimals}
    allowNegative={false}
    inputMode='decimal'
    maxLength="5"
  />
);

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  decimals: PropTypes.number
};

const NumberTextfield = props => {
  const {
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    handleOnChange,
    decimalscale,
    ...rest
  } = props;


  const handleTextFieldChange = values => {
    if(field.value !== values.floatValue) {
      if (handleOnChange) {
        handleOnChange(values);
      }
      setFieldValue(field.name, values.floatValue);
    }
  };

  return (
    <React.Fragment>
      <StyledWrapper>
        <StyledTextField
          type="text"
          margin="none"
          variant="filled"
          fullWidth
          error={!!(touched[field.name] && errors[field.name])}
          InputProps={{
            disableUnderline: true,
            inputComponent: NumberFormatCustom,
            inputProps: {
              decimals: decimalscale
            }
          }}
          autoComplete="off"
          {...rest}
          {...field}
          onChange={handleTextFieldChange}
        />
        <ErrorMessage className="error-message" component="div" name={field.name} />
      </StyledWrapper>
    </React.Fragment>
  );
};
NumberTextfield.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  handleOnChange: PropTypes.func,
  decimalscale: PropTypes.number
};

NumberTextfield.defaultProps = {
  decimalscale: 0
};

const NumberField = props => <Field component={NumberTextfield} {...props} />;

export default NumberField;
